import { BlockComponentModel } from '@/cms/types/blok-component';
import Heading from '@/components/atoms/Heading';
import RichTextFieldSB from '@/components/atoms/RichTextField/RichTextFieldStrapi';
import { applyToAllRTFVariants } from '@/components/atoms/RichTextField/utils';
import { AccordionItemProps } from '@/components/molecules/accordion/AccordionItem';
import {
  AccordionContentItem,
  resolveContentBlock,
} from '@/components/molecules/accordion/accordionContent';
import AccordionList from '@/components/molecules/accordion/AccordionList';

export interface AccordionListStrapiProps {
  accordionList: AccordionContentItem[];
}

interface AccordionListProps {
  internal?: {
    ContainerProps?: React.HTMLAttributes<HTMLDivElement>;
    accordionItem: Partial<AccordionItemProps>;
  };
}

export default function AccordionListStrapi({
  block,
  internal,
}: BlockComponentModel<AccordionListStrapiProps> & AccordionListProps) {
  const { accordionList } = block;
  const { accordionItem, ContainerProps } = internal || {};

  // Needed to strip empty paragraphs added in Strapi by content in all blog post FAQs
  function stripEmptyParagraphs(blocks: any[]): any[] {
    return blocks.filter((block) => {
      if (block.type !== 'paragraph') return true;
      if (
        Array.isArray(block.children) &&
        block.children.every(
          (child: any) =>
            typeof child.text === 'string' && child.text.trim() === ''
        )
      ) {
        return false;
      }
      return true;
    });
  }

  const formattedAccordionList =
    accordionList?.map((item, index) => {
      const contentBlock = resolveContentBlock(item, stripEmptyParagraphs);
      return {
        header: (
          <Heading
            level='h3'
            classNames={{ root: 'text-subtitle-l-d' }}
            data-tracker-context={`accordion-header-${index}`}
          >
            {item.header}
          </Heading>
        ),
        children: (
          <div className='flex flex-col gap-4'>
            <RichTextFieldSB
              block={contentBlock}
              classNames={{
                ...applyToAllRTFVariants('text-mono'),
                link: { root: 'text-brand-500' },
              }}
            />
          </div>
        ),
      };
    }) || [];

  return (
    <AccordionList
      accordionList={formattedAccordionList}
      internal={{ accordionItem, ContainerProps }}
    />
  );
}
